import { Download } from "lucide-react";

const B = process.env.REACT_APP_BACKEND_URL;
export const recUrl = (id, download) => `${B}/api/recordings/${id}/stream${download ? "?download=1" : ""}`;
export const fmtDur = (s) => (s ? `${Math.floor(s / 60)}m ${String(s % 60).padStart(2, "0")}s` : "—");
export const fmtSize = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round((b || 0) / 1024))} KB`);

export const RecordingPlayer = ({ rec }) => (
  <video controls preload="metadata" src={recUrl(rec.id)} className="w-full rounded-lg bg-black aspect-video" data-testid={`recording-video-${rec.id}`} />
);

export const DownloadLink = ({ rec }) => (
  <a href={recUrl(rec.id, true)} className="inline-flex items-center gap-1 text-sm font-semibold text-blue-600 hover:underline" data-testid={`recording-download-${rec.id}`}>
    <Download className="w-4 h-4" />Download
  </a>
);
